import type { TComponent } from 'utils/types/component';

import type { TBalance } from 'models/Merchant/Balance';

import { BalanceInfo } from '../BalanceInfo';
import styles from './CommonContent.module.scss';

interface ICommonContentProps {
    item: TBalance;
}

export const CommonContent: TComponent<ICommonContentProps> = ({ item }) => {
    const balanceDifference = item.currentBalance - item.previousDayBalance;

    return (
        <>
            <div className={styles.mainInfo}>
                <BalanceInfo
                    balanceInfo={item.currentBalance}
                    title='balance.tabs.todayBalance'
                    balanceDifference={balanceDifference}
                />
                <BalanceInfo
                    balanceInfo={item.previousDayBalance}
                    title='balance.tabs.previousDayBalance'
                />
            </div>
            <div className={styles.additionalInfo}>
                <BalanceInfo
                    balanceInfo={item.currentFrozenBalance}
                    title='balance.tabs.frozenBalance'
                    commissionTitle='balance.tabs.frozenCommissionBalance'
                    commissionInfo={item.currentFrozenCommissionBalance}
                />
                <BalanceInfo
                    balanceInfo={item.todayDepositAmount}
                    title='balance.tabs.deposits'
                    commissionInfo={item.todayDepositCommissionAmount}
                />
                <BalanceInfo
                    balanceInfo={item.todayPayoutAmount}
                    title='balance.tabs.payouts'
                    commissionInfo={item.todayPayoutCommissionAmount}
                />
                <BalanceInfo
                    balanceInfo={item.todayPrepaymentAmount}
                    title='balance.tabs.prepayments'
                    commissionInfo={item.todayPrepaymentCommissionAmount}
                />
                <BalanceInfo
                    balanceInfo={item.todayRefundAmount}
                    title='balance.tabs.refunds'
                    commissionInfo={item.todayRefundCommissionAmount}
                />
                <BalanceInfo
                    balanceInfo={item.todayChargebackAmount}
                    title='balance.tabs.chargebacks'
                    commissionInfo={item.todayChargebackCommissionAmount}
                />
                <BalanceInfo
                    balanceInfo={item.todayPayoutRefundAmount}
                    title='balance.tabs.refundsPayouts'
                    commissionInfo={item.todayPayoutRefundCommissionAmount}
                />
                <BalanceInfo
                    balanceInfo={item.todayDepositSurchargeAmount || 0}
                    title='balance.tabs.depositSurcharges'
                    commissionInfo={
                        item.todayDepositSurchargeCommissionAmount || 0
                    }
                />
            </div>
        </>
    );
};
